import axios from "axios";
import { LoadingModal } from "@/utils/loading-modal.js";
import * as Sentry from "@sentry/browser";

const baseUrl = process.env.VUE_APP_BACKEND_HOST; //TODO IR BUSCAR SYS VAR

export default {
  async login(context, payload) {
    // LoadingModal.show("Autenticação em processo...", true);
    try {
      let res = await axios.post(`${baseUrl}/auth/login`, {
        user: {
          email: payload.email,
          password: payload.password,
        },
      });

      if (res.data.force_cache_clean) {
        localStorage.removeItem("databuilderQuery");
      }

      context.commit("setUser", {
        token: res.headers.authorization,
        userId: res.data.userSetings.user_id,
        userName: res.data.userSetings.user_name,
        department: res.data.userSetings.department,
        rules: res.data.rules,
        userRole: res.data.userSetings.user_role
      });

      Sentry.setUser({ id: res.data.userSetings.user_id, username: res.data.userSetings.user_name });
      localStorage.setItem("token", res.headers.authorization);
      localStorage.setItem("token_create_date", new Date().getTime());
      localStorage.setItem("userId", res.data.userSetings.user_id);
      localStorage.setItem("userName", res.data.userSetings.user_name);
      localStorage.setItem(
        "department",
        JSON.stringify(res.data.userSetings.department)
      );
      localStorage.setItem("rules", JSON.stringify(res.data.rules));
      localStorage.setItem("userRole", JSON.stringify(res.data.userSetings.user_role));
      // for analytics purposes
      localStorage.setItem("internalTraffic", res.data.userSetings.user_role == 'super_admin');
      // LoadingModal.hide();
      return res;
    } catch (err) {
      if (err.message == "Network Error") {
        return { data: { message: "Erro de ligação ao servidor" } };
      } else if (err.response.status == 401) {
        return { data: { message: "Credenciais inválidas" } };
      } else {
        new Error("Failed to authenticate user", err);
      }
      // LoadingModal.hide();
    }
  },

  tryLogin(context) {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("userName");
    const department = localStorage.getItem("department");
    const rules = localStorage.getItem("rules");
    const versionData = localStorage.getItem("versionData");
    const userRole = localStorage.getItem("userRole");

    if (token && userId) {
      context.commit("setUser", {
        token: token,
        userId: userId,
        userName: userName,
        department: department,
        rules: rules,
        versionData: versionData,
        userRole: userRole,
      });
      Sentry.setUser({ id: userId, username: userName });
    }
  },
  async logout(context) {
    // we never remove internal_traffic
    LoadingModal.show("A terminar sessão...", true);
    try {
      const response = await axios.delete(`${baseUrl}/auth/logout`, {
        headers: {
          Authorization: context.state.token,
        },
      });

      if (response.status == 200) {
        context.commit("setUser", {
          token: null,
          userId: null,
          userName: null,
          department: null,
          rules: {},
          versionData: null,
          userRole: null
        });
        Sentry.setUser(null);

        localStorage.removeItem("token");
        localStorage.removeItem("token_create_date");
        localStorage.removeItem("userId");
        localStorage.removeItem("userName");
        localStorage.removeItem("department");
        localStorage.removeItem("rules");
        localStorage.removeItem("versionData");
        localStorage.removeItem("userRole");
      }
      LoadingModal.hide();
    } catch (err) {
      const output = new Error("Failed to logout user");
      LoadingModal.hide();
      throw output;
    }
  },
  destroyLocalSession(context) {
    context.commit("setUser", {
      token: null,
      userId: null,
      userName: null,
      department: null,
      rules: {},
      userRole: null
    });

    Sentry.setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("token_create_date");
    localStorage.removeItem("userId");
    localStorage.removeItem("userName");
    localStorage.removeItem("department");
    localStorage.removeItem("rules");
    localStorage.removeItem("versionData");
    localStorage.removeItem("userRole");
  },
  autoLogout(context) {
    context.dispatch("destroyLocalSession");
    context.commit("setAutoLogout");
  },
  async setPassword(context, payload) {
    // try {
    const response = await axios.post(`${baseUrl}/auth/pw_verification`, {
      user: {
        token: payload.token,
        password: payload.password,
        password_verification: payload.password_verification,
      },
    });

    return response;
    // } catch (err) {
    //   const output = new Error("Failed to login user");
    //   throw output;
    // }
  },
  async recover(context, payload) {
    try {
      return await axios.post(`${baseUrl}/auth/password_recover`, {
        user: {
          email: payload.email,
        },
      });
    } catch (err) {
      return err;
    }
  },
  triggerRefreshFlag(context) {
    context.commit("setFlagNeedsRefresh");
  }
};
